import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-codigo-lancamento-edit',
  templateUrl: './codigo-lancamento-edit.component.html',
  styleUrls: ['./codigo-lancamento-edit.component.css'],
  standalone: false
})
export class CodigoLancamentoEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/codigo-lancamento`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Cadastro Codigo de Lançamento', link: '/codigo-lancamento' }, { label: 'Edição Codigo de Lançamento' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'codigo-lancamento',
      // saveNew: '/cliente',
  };

  fields: PoPageDynamicEditField[] = []
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;


  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema("codigo-lancamento").subscribe((data) => {
        this.fields = data;
    });
  }
}
